export default "/build/images/6.png?1aba696b434d70c6146e59b443c2627f";